export default __webpack_public_path__ + "static/team-4-2d1dba4e5c77ac9ed4270672c7cc0dae.jpg";